var map = {
	"./01record.svg": "RlB3",
	"./02to.svg": "egmW",
	"./03Alcohol.svg": "F3yW",
	"./03AlcoholActive.svg": "7zgm",
	"./03Coffee.svg": "RaeE",
	"./03CoffeeActive.svg": "VIBT",
	"./03Medicine.svg": "XKfo",
	"./03MedicineActive.svg": "f88v",
	"./03Milk.svg": "dVpD",
	"./03MilkActive.svg": "p17S"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a02r";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/status/30myJournal ^\.\/.*\.svg$
// module id = a02r
// module chunks = 0